export default __webpack_public_path__ + "static/domea-5-dd6f323ec42822ce03e26bcc6e641334.jpg";